const free_max_sessions = process.env.REACT_APP_FREE_MAX_SESSIONS
const subscribe_max_sessions =
  process.env.REACT_APP_SUBSCRIBE_MAX_SESSIONS_PER_YEAR
const subscribe_price_per_year = process.env.REACT_APP_SUBSCRIBE_PRICE_PER_YEAR

export const langLogin = {
  fr: {
    profile: `Mon compte`,
    continue: `Continuer`,
    cancel: `Annuler`,
    signedUp: `Déjà inscrit ?`,
    address: `Adresse email`,
    pwd: `Mot de passe`,
    code: `Code de confirmation`,
    userName: `Nom d'utilisateur`,
    accountType: `Type de compte`,
    freeAccount: `gratuit`,
    changeForSubscribe: `M'abonner`,
    doSubscribeTitle: `Je m'abonne.`,
    subscribeAccount: `abonnement se terminant au `,
    oldSubscribeAccount: `gratuit, dernier abonnement échu au `,
    identify: `M'identifier`,
    alertNotCorrect: `Les données saisies sont incorrectes. Veuillez les vérifier et réessayer.`,
    firstVisit: `Il s’agit de votre première visite ou vous n’êtes pas encore inscrit(e).`,
    create: `Créer un compte gratuit`,
    createDetail:
      `Un compte gratuit vous permet d'enregistrer ` +
      free_max_sessions +
      ` sessions au total.`,
    createTitle: `Je crée un compte gratuit`,
    createOkTitle: `Création de compte gratuit confirmée`,
    subscribeOkTitle: `Création de compte abonné confirmée`,
    createOK1: `Votre compte gratuit a été créé.`,
    createOK2:
      `Il vous permet d'enregistrer ` +
      free_max_sessions +
      ` sessions au total.`,
    createOK3: `Vous pouvez maintenant vous identifier pour accèder à votre compte.`,
    subscribe: `Créer un compte abonné`,

    subscribeDetail:
      `Un compte abonné vous permet d'enregistrer jusqu'à ` +
      subscribe_max_sessions +
      ` sessions par an. Le prix de l'abonnement annuel est de ` +
      subscribe_price_per_year +
      ` euros. Il sert à financer une partie des frais liés à l'hébergement des données sur un serveur sécurisé.`,
    subscribeTitle: `Je crée un compte abonné`,
    subscribePriceMention1: `Abonnement : `,
    subscribePriceMention2: ` euros par an, à règler en utilisant paypal.`,
    subscribeOKTitle: `Création de compte abonné confirmée`,
    subscribeOK1: `Votre compte abonné a été créé.`,
    subscribeOK2:
      `Il vous permet d'enregistrer jusqu'à ` +
      subscribe_max_sessions +
      ` sessions par an.`,
    subscribeOK3: `Vous pouvez maintenant vous identifier pour accèder à votre compte.`,
    subscribedCanceledTitle: `Création de compte annulée`,
    subscribeCanceled1: `Vous avez annulé la création de votre compte abonné.`,
    subscribeModified: `Votre abonnement a bien été enregistré.`,
    setAddress: `Saisissez une adresse email`,
    alertAddress: `L'adresse email n'est pas valide.`,
    alertAddressUsed: `L'adresse email saisie est déjà utilisée par un compte.`,
    setCode: `Saisissez le code de confirmation qui vous a été envoyé par mail à l'adresse `,
    alertCode: `6 chiffres exactement, sans espaces`,
    alertCodeNotOk: `Le code saisi ne correspond pas à celui qui vous a été envoyé.`,
    setUser: `Saisissez votre nom d'utilisateur`,
    alertUser: `5 caract. mini, 20 caract. maxi.`,
    setPwd: `Saisissez votre mot de passe et confirmez-le`,
    alertPwd: `6 caract. mini, 20 caract. maxi`,
    alertPwdNoMatch: `Les mots de passe ne sont pas identiques.`,
    pwdConfirm: `Confirmation du mot de passe`,
    modify: `Modifier`,
    setNewAddress: `Saisissez votre nouvelle adresse email`,

    setNewUsername: `Saisissez votre nouveau nom d'utilisateur`,

    setNewPwd: `Saisissez votre nouveau mot de passe et confirmez-le`,

    addressModified: `Votre adresse email a été modifiée`,
    userNameModified: `Votre nom d'utilisateur a été modifié`,
    pwdModified: `Votre mot de passe a été modifié`,
    deleteAccount: `Supprimer le compte`,
    pwdLost: `J'ai oublié mon mot de passe`,
    setPwdLostAddress: `Saisissez l'adresse email associée à votre compte`,
    noAccountWithEmail: `Il n'y a pas de compte correspondant à cette adresse mail`,
    pwdLostReplaced: `Votre mot de passe a été remplacé.`,
  },
  eng: {
    profile: `My account`,
    continue: `Continue`,
    cancel: `Cancel`,
    signedUp: `Already signed up ?`,
    address: `Email address`,
    pwd: `Password`,
    code: `Confirmation code`,
    userName: `Username`,
    accountType: `Account type`,
    freeAccount: `free`,
    subscribeAccount: `subscription ending on `,
    oldSubscribeAccount: `free, last subscription expired on `,
    changeForSubscribe: `Subscribe`,
    doSubscribeTitle: `I subscribe.`,
    identify: `Log in`,
    alertNotCorrect: `Data entered is incorrect, please verify and retry.`,
    firstVisit: `This is your first visit or you are not yet registered.`,
    create: `Create a free account`,
    createDetail:
      `A free account allows you to record ` +
      free_max_sessions +
      ` sessions in total.`,
    createTitle: `I create a free account`,
    createOkTitle: `Free account creation confirmed`,
    subscribeOkTitle: `Subscriber account creation confirmed`,
    createOK1: `Your free account has been created.`,
    createOK2:
      `It allows you to save ` + free_max_sessions + ` sessions au total.`,
    createOK3: `You can now identify yourself to access your account.`,
    subscribe: `Create a subscriber account`,
    subscribeDetail:
      `A subscriber account allows you to save up to ` +
      subscribe_max_sessions +
      ` sessions per year. The annual subscription price is ` +
      subscribe_price_per_year +
      ` euros. It is used to finance a part of the costs associated with hosting data on a secure server.`,
    subscribeTitle: `I create a subscriber account`,
    subscribePriceMention1: `Subscription : `,
    subscribePriceMention2: ` euros per year, to be paid using paypal.`,
    subscribeOKTitle: `Subscriber account creation confirmed`,
    subscribeOK1: `Your subscriber account has been created.`,
    subscribeOK2:
      `It allows you to save up to ` +
      subscribe_max_sessions +
      ` sessions per year.`,
    subscribeOK3: `You can now identify yourself to access your account.`,
    subscribedCanceledTitle: `Account creation canceled`,
    subscribeCanceled1: `You have canceled the creation of your subscriber account.`,
    subscribeModified: `Your subscription has been registered.`,
    setAddress: `Enter an email address`,
    alertAddress: `Email address is not valid.`,
    alertAddressUsed: `The email address entered is already used by an account.`,
    setCode: `Enter the confirmation code that was emailed to you at `,
    alertCode: `6 digits exactly, no spaces`,
    alertCodeNotOk: `The code entered does not match the one sent to you.`,
    setUser: `Enter your username`,
    alertUser: `5 characters mini, 20 characters maxi.`,
    setPwd: `Enter and confirm your password`,
    alertPwd: `6 characters mini, 20 characters maxi.`,
    alertPwdNoMatch: `Passwords are not identical.`,
    pwdConfirm: `Password confirmation`,
    modify: `Edit`,
    setNewAddress: `Enter your new email address`,

    setNewUsername: `Enter your new username`,

    setNewPwd: `Enter and confirm your new password`,

    addressModified: `Your email address has been changed`,
    userNameModified: `Your username has been changed`,
    pwdModified: `Your password has been changed`,
    deleteAccount: `Delete account`,
    pwdLost: `I forgot my password`,
    setPwdLostAddress: `Enter the email address associated with your account`,
    noAccountWithEmail: `There is no account corresponding to this email address`,
    pwdLostReplaced: `Your password has been replaced.`,
  },
}
